export const translationStatistics_da_part1 = {
  recentReports: "Seneste rapporter",
  reportJobsHelp:
    "Rapporter fortsætter i baggrunden. Vend tilbage hertil for at hente dem i syv dage.",
  reportQueued: "Rapporten er sat i kø. Følg status under Seneste rapporter.",
  reportJobsLoadError: "Rapporterne kunne ikke hentes eller opdateres. Prøv igen.",
  reportRefusedScopeEmpty:
    "Den aktuelle visning indeholder ingen chatbots at lave rapport om. Vælg chatbots øverst på siden, og prøv igen.",
  reportRefusedAccessDenied:
    "Du har ikke adgang til alle de valgte chatbots. Vælg chatbots, du har adgang til, og prøv igen.",
  reportRefusedQueueFull:
    "Der er for mange rapporter i kø lige nu. Prøv igen, når en rapport i kø er færdig.",
  reportRefusedDateRange: "Den valgte periode er ugyldig. Tjek start- og slutdatoen.",
  reportJob_queued: "I kø",
  reportJob_statistics: "Forbereder statistik",
  reportJob_analysis: "Analyserer samtaler",
  reportJob_rendering: "Genererer PDF",
  reportJob_uploading: "Gemmer rapport",
  reportJob_delivery: "Sender planlagt rapport",
  reportJob_ready: "Klar til download",
  reportJob_failed: "Rapporten mislykkedes",
  reportJob_cancelled: "Annulleret",
  reportJob_expired: "Udløbet",
  reportJob_complete: "Færdig",
  reportJobAnalysisInterrupted: "Analysen blev afbrudt. Generér en ny rapport for at prøve igen.",
  reportJobTooLarge:
    "Rapporten er for stor til at blive genereret. Vælg en kortere periode eller færre chatbots.",
  reportJobBusy:
    "Rapporttjenesten var optaget og kunne ikke færdiggøre rapporten. Kør den igen om et par minutter.",
  reportJobTimeout:
    "Rapporten tog for lang tid at generere. Kør den igen, eller vælg en kortere periode.",
  reportJobAccess: "Du har ikke længere adgang til alle chatbots i rapporten.",
  reportJobDeliveryFailed: "Rapporten blev genereret, men dens e-mail kunne ikke sendes.",

  tokenMissing: "Token eller chatbotID ikke fundet",
  choosePeriod: "Periode",
  topicFilterLabel: "Emne",
  topicFilterAllPlaceholder: "Alle emner",
  topicFilterOtherOption: "Andet",
  topicFilterArchivedLabel: "arkiveret",
  topicFilterClear: "Ryd emnefilter",
  topicFilterSelectedCount: "{count} emner",
  topicGroupSave: "Gem som gruppe",
  topicGroupSaveConfirm: "Gem",
  topicGroupName: "Gruppenavn",
  topicGroupNamePlaceholder: "F.eks. Kundeservice",
  topicGroupDelete: "Slet gruppe",
  topicFilterReportNotice:
    "Sidens emnefilter anvendes ikke i rapporter – rapporten dækker alle emner.",
  allTimes: "Alle Tider",
  last7Days: "Seneste 7 Dage",
  last30Days: "Seneste 30 Dage",
  last3Months: "Sidste 3 måneder",
  yesterday: "I går",
  today: "I dag",
  customRange: "Brugerdefineret",
  statisticsTabPerformance: "AI-præstation",
  statisticsTabTopics: "Emner & samtaler",
  statisticsTabListLabel: "Statistiksektioner",
  overviewSectionTitle: "Overblik",
  resolutionSectionTitle: "Løsning",
  aiEffectivenessSectionTitle: "AI-effektivitet",
  commerceSectionTitle: "Forretningspåvirkning",
  viewConversations: "Se samtaler",
  comparePreviousPeriod: "Sammenlign med forrige periode",
  vsPreviousPeriod: "vs. forrige periode",
  comparePreviousPeriodTooltip:
    "Viser, hvordan hver KPI ændrede sig i forhold til den foregående periode af samme længde.",
  comparePreviousPeriodUnavailableTooltip:
    "Sammenligning er ikke tilgængelig for Alle tider, fordi der ikke findes en gyldig foregående periode.",
  comparePreviousPeriodInfo: "Info om sammenligning med forrige periode",
  lastUpdated: "Sidst opdateret",
  refresh: "Opdater",
  actions: "Handlinger",
  allChatbots: "Alle chatbots",
  conversationsBySource: "Samtaler efter kilde",
  conversationsBySourceTotal: "{total} samtaler i den valgte periode",
  noSourceData: "Ingen kildedata for denne periode.",
  statisticsLoadError: "Kunne ikke indlæse statistik",
  statisticsLoadErrorDescription: "Prøv at opdatere siden.",
  outcomeBreakdownTitle: "Løsningsresultater",
  outcomeBreakdownPartitionHint:
    "Hvert udfald er en andel af klassificerede samtaler (dem med en løsningskategori) og summerer til 100%. Uklassificerede samtaler indgår ikke.",
  resolutionTotalLabel: "Klassificerede samtaler",
  resolutionCoverageLabel: "Klassificerede samtaler: {classified} af {total} ({percent}%)",
  activitySectionTitle: "Aktivitet",
  hourLabel: "Time",
  messagesLabel: "Beskeder",
  performanceSectionDescription:
    "AI-effektivitet, eskaleringer og engagement for den valgte periode.",
  satisfactionChartsTitle: "Tilfredshed",
  statisticsSettingsDescription: "Konfigurer åbningstider, synlige målinger og emnehåndtering.",
  notificationsSheetDescription: "Få besked når emnevolumen stiger over en tærskel.",
  viewTopicDetails: "Se emnedetaljer",
  livechatVolumeTitle: "Livechat-volumen",
  livechatSatisfactionTitle: "Livechat-tilfredshed",
  livechatTopicsTitle: "Livechat-emner",

  insights: "Indsigter",
  totalMessages: "Total antal beskeder",
  avgMessagesPerDay: "Gennemsnitlig antal beskeder per dag",
  totalConversations: "Total antal samtaler",
  totalUserRatings: "Total antal bruger vurderinger",
  averageRating: "Gennemsnitlig bruger vurdering",
  thumbsUpPercentage: "Procent tommel op",
  csatScore: "Kundetilfredshed (CSAT)",
  chatbotSatisfaction: "Chatbot Tilfredshed",

  dailyMessages: "Daglige beskeder",
  weeklyMessages: "Ugentlige beskeder",
  weekOf: "Uge fra",
  ongoingDay: "Igangværende dag",
  weekInProgress: "Igangværende uge",
  loadingDailyData: "Loader daglig data...",
  topicMessages: "Samtaler fordelt på emne",
  loadingTopicData: "Loader emne data...",
  timeOfDay: "Tidspunkt på dagen",
  loadingHourlyData: "Loader timelig data...",
  ratingDistribution: "Fordeling af vurderinger (1-5)",
  ratingDistributionTooltip:
    "Antal samtaler med brugervurdering for hvert niveau (kun heltalsvurderinger 1-5).",
  ratingDistributionEmpty: "Ingen vurderinger i denne periode endnu",
  csatOverTime: "CSAT over tid",
  csatOverTimeTooltip:
    "Gennemsnitlig kundetilfredshed (CSAT) pr. periode i den valgte tidsperiode.",
  csatOverTimeEmpty: "Ingen vurderinger i denne periode endnu",
  csatOverTimeYAxis: "CSAT (%)",
  csatRegressionLine: "Trendlinje",
  csatRegressionSlopeDay: "{{slope}} pp / dag",
  csatRegressionSlopeWeek: "{{slope}} pp / uge",
  csatRegressionSlopeMonth: "{{slope}} pp / måned",
  resolutionOverTime: "Løsningsrate over tid",
  resolutionOverTimeEmpty: "Ingen klassificerede samtaler i denne periode endnu",
  resolutionOverTimeYAxis: "Løsning (%)",
  csatOverTimeChartSetting: "CSAT over tid-graf",
  csatOverTimeChartSettingTooltip:
    "Vis en linjegraf over udviklingen i CSAT-score over den valgte periode.",

  dateLabel: "Dato",
  messageCount: "Antal beskeder",
  topicLabel: "Emne",
  conversationCount: "Antal samtaler",
  openCount: "Antal åbninger",
  timeLabel: "Tid",
  showAll: "Vis alle",
  showLess: "Vis færre",
  other: "Andre",
  percentage: "Procent",

  // New translations for report generation

  // New translations for report generation
  generateReport: "AI Rapport",
  generateReportTitle: "AI Statistik Rapport",
  selectReportTimePeriod: "Vælg tidsperiode for rapporten",
  selectReportEmne: "Vælg emne (valgfrit)",
  allTopics: "Alle emner",
  cancel: "Annuller",
  reportGeneratedSuccess: "Rapport genereret og downloadet",
  reportGenerationError: "Fejl ved generering af rapport",
  reportAiAnalysisFailed:
    "Rapporten blev genereret, men AI-indsigterne kunne ikke laves. Prøv igen senere.",
  includeTextAnalysis: "Inkluder tekstanalyse (ordkorrelation)",
  includeGPTAnalysis: "Inkluder AI-analyse og indsigter",
  maxConversations: "Antal samtaler der skal analyseres",
  loading: "Indlæser...",
  companyInfo: "Virksomhedsinformation",
  statistics: "Statistik",
  companyInfoPlaceholder: "Indtast virksomhedsinformation her...",
  startDate: "Start dato",
  endDate: "Slut dato",
  // Purchase tracking translations
  // Purchase tracking translations
  totalPurchases: "Totale køb",
  totalRevenue: "Total omsætning",
  averagePurchaseValue: "Gennemsnitlig købsværdi",
  conversionRate: "Konverteringsrate",
  storeTotalPurchases: "Butikkens køb (alle)",
  storeTotalRevenue: "Butikkens omsætning (alle)",
  storeAveragePurchaseValue: "Butikkens gennemsnitlige ordreværdi (alle)",
  storeConversionRate: "Butikkens konverteringsrate (alle)",
  storeConversionRateVisitors: "Butikkens konverteringsrate (pr. daglig besøgende)",
  returnRate: "Returrate",
  returnValueRate: "Returneret omsætning",
  returnUnitRate: "Returnerede varer",
  storeReturnRate: "Butikkens returrate (alle)",
  storeReturnValueRate: "Butikkens returnerede omsætning (alle)",
  storeReturnUnitRate: "Butikkens returnerede varer (alle)",
  returnCohortBasis: "Modne ordrer",
  returnCurveTitle: "Returneringer efter ordrealder",
  returnCurveChatbotSeries: "Chatbot-samtaler",
  returnCurveStoreSeries: "Hele butikken",
  returnCurveFooter:
    "Tal i parentes er antal modne ordrer bag punktet. Kunder der skriver til chatbotten er ikke et tilfældigt udsnit af kunderne, så forskellen mellem linjerne beskriver de to grupper — den beviser ikke en effekt af chatbotten.",
  trackingSince: "Sporing siden",
  // Fallback rate translations
  // Fallback rate translations
  resolutionRate: "Løsningsrate",
};
